(function () {
  'use strict';

  if (window.PGHomeLaunchV13) return;
  window.PGHomeLaunchV13 = true;

  var queued = false;
  var observer = null;

  function isHomepage() {
    var body = document.body;
    return Boolean(body && (
      body.classList.contains('index') ||
      body.classList.contains('template-index') ||
      document.querySelector('[data-pg-home-shelf], .pg-home-shelf-host, .tab_collections_section')
    ));
  }

  function isRendered(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01 &&
      rect.width > 20 &&
      rect.height > 8;
  }

  function firstCollection() {
    var candidates = [
      document.querySelector('[data-pg-home-shelf]'),
      document.querySelector('.pg-home-shelf-host'),
      document.querySelector('.tab_products.costume_tab_prod')
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      if (isRendered(candidates[index])) return candidates[index].closest('.shopify-section') || candidates[index];
    }

    return null;
  }

  function isTopLayer(element, shell) {
    if (!element || element === document.body || element === document.documentElement) return false;
    if (element === shell || element.closest('[data-pg-home-sticky-shell]')) return false;
    if (!isRendered(element)) return false;

    var style = window.getComputedStyle(element);
    if (style.position !== 'fixed' && style.position !== 'sticky') return false;

    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 &&
      rect.top < 260 &&
      rect.width >= window.innerWidth * 0.48 &&
      rect.height <= 220;
  }

  function topStackBottom(shell) {
    var bottom = 0;
    var seen = [];
    var selectors = [
      '#header',
      'header',
      '.header',
      '.sticky_nav',
      '.sticky-header',
      '.header-sticky-wrapper',
      '.shopify-section--header',
      '.shopify-section-group-header-group',
      '[data-sticky-header]',
      '[class*="announcement"]',
      '[id*="announcement"]',
      '[class*="promo-bar"]',
      '[id*="promo-bar"]',
      '[class*="top-bar"]',
      '[id*="top-bar"]',
      '[class*="trust-bar"]',
      '[id*="trust-bar"]'
    ].join(',');

    function inspect(element) {
      if (!element || seen.indexOf(element) !== -1) return;
      seen.push(element);
      if (!isTopLayer(element, shell)) return;
      bottom = Math.max(bottom, element.getBoundingClientRect().bottom);
    }

    document.querySelectorAll(selectors).forEach(inspect);

    if (document.elementsFromPoint) {
      var scanLimit = Math.min(240, Math.max(140, window.innerHeight * 0.3));
      var xPoints = [2, Math.round(window.innerWidth / 2), Math.max(2, window.innerWidth - 2)];

      for (var y = 2; y <= scanLimit; y += 12) {
        xPoints.forEach(function (x) {
          document.elementsFromPoint(x, y).forEach(function (element) {
            var current = element;
            var depth = 0;
            while (current && current !== document.body && depth < 5) {
              inspect(current);
              current = current.parentElement;
              depth += 1;
            }
          });
        });
      }
    }

    return Math.max(0, Math.ceil(bottom));
  }

  function installLogo(shell) {
    var target = shell.querySelector('[data-pg-sticky-logo]');
    if (!target || target.dataset.pgLogoReady === 'true') return;

    var source = document.querySelector('#header .mobile_logo img, [data-desktop-header] .header__logo img');
    if (!source) return;

    var image = document.createElement('img');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt || 'Paw & Glory';
    image.width = source.naturalWidth || 200;
    image.height = source.naturalHeight || 80;
    image.loading = 'eager';

    target.replaceChildren(image);
    target.dataset.pgLogoReady = 'true';
  }

  function bindMenu(shell) {
    var button = shell.querySelector('[data-pg-sticky-menu]');
    if (!button || button.dataset.pgMenuReady === 'true') return;

    button.dataset.pgMenuReady = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var trigger = document.querySelector('[data-mobile-menu-trigger]');
      if (trigger) trigger.click();
    });
  }

  function currentShell() {
    var shells = Array.prototype.slice.call(document.querySelectorAll('[data-pg-home-sticky-shell]'));
    if (!shells.length) return null;

    var shell = shells[shells.length - 1];
    shells.slice(0, -1).forEach(function (duplicate) {
      if (duplicate !== shell) duplicate.remove();
    });

    return shell;
  }

  function update() {
    queued = false;
    if (!isHomepage()) return;

    var shell = currentShell();
    if (!shell) return;

    if (shell.parentNode !== document.body) document.body.appendChild(shell);
    installLogo(shell);
    bindMenu(shell);

    var top = topStackBottom(shell);
    var collection = firstCollection();
    var visible = Boolean(collection && collection.getBoundingClientRect().bottom <= top + 2);

    shell.style.setProperty('--pg-sticky-top', top + 'px');
    shell.setAttribute('data-pg-visible', visible ? 'true' : 'false');
    shell.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function queueUpdate() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }

  function startObserver() {
    if (observer || !window.MutationObserver || !document.body) return;
    observer = new MutationObserver(queueUpdate);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    if (!isHomepage()) return;

    update();
    startObserver();
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate, { passive: true });
    window.addEventListener('pageshow', queueUpdate, { passive: true });

    [100, 300, 700, 1400, 2500, 4500].forEach(function (delay) {
      window.setTimeout(update, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(update, 0);
  });
})();
